import { PERMISSIONS } from './usersPermissions/usersPermissionsCultivares';

export const isDescriptors = (roles: string[]): boolean =>
{
	let isRole = roles.filter(role => role === PERMISSIONS.ReqRegistroAvaliarDescritor)
	return isRole.length ? true : false;
}